import Q from 'q';
import $ from 'jquery';

import * as ol from 'ol';
import * as layer from 'ol/layer';
import * as source from 'ol/source';
import * as format from 'ol/format'
import * as style from 'ol/style';
import * as interaction from 'ol/interaction';

import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import * as proj from 'ol/proj';

import {containsXY, createEmpty, extend, getCenter, isEmpty} from 'ol/extent';
import {optionsFromCapabilities} from 'ol/source/WMTS';
import {isMobile, isIe} from './Helper'

if (!Array.prototype.last) {
    Array.prototype.last = function () {
        return this[this.length - 1];
    };
}

function Map(options) {
    this.satdopLayer = new layer.Tile({preload: 7, opacity: 1, visible: false});
    this.webatlasLayer = new layer.Tile({preload: 7, opacity: 1, visible: true});
    this.stimmkreiseLayer = new layer.Vector({name: 'stimmkreis', updateWhileAnimating: false});

    let renderBuffer = isIe() ? 100 : 700;
    let hitTolerance = isIe() ? 10 : 0;

    this.abgeordnetenPinsOptions = {
        name: 'pin',
        updateWhileAnimating: false,
        hitTolerance: hitTolerance,
        renderBuffer: renderBuffer
    };
    this.abgeordnetenImagesOptions = {
        name: 'image',
        updateWhileAnimating: false,
        renderBuffer: renderBuffer,
        hitTolerance: hitTolerance,
        minZoom: 11
    };
    this.abgeordnetenTweetsOptions = {
        name: 'tweet',
        updateWhileAnimating: false,
        renderBuffer: renderBuffer,
        hitTolerance: hitTolerance,
        minZoom: 11
    };
    this.abgeordnetenVideosOptions = {
        name: 'video',
        updateWhileAnimating: false,
        renderBuffer: renderBuffer,
        hitTolerance: hitTolerance,
        minZoom: 11
    };
    this.abgeordnetenTextsOptions = {
        name: 'text',
        updateWhileAnimating: false,
        renderBuffer: renderBuffer,
        hitTolerance: hitTolerance,
        minZoom: 13
    };

    this.abgeordnetenPinsLayers = {};
    this.abgeordnetenImagesLayers = {};
    this.abgeordnetenTweetsLayers = {};
    this.abgeordnetenVideosLayers = {};
    this.abgeordnetenTextsLayers = {};

    this.wahlkreise = {};
    this.stimmkreise = {};

    this.abgeordnete = {};

    let i = 0;
    this.satdopLayerPosition = i;
    this.webatlasLayerPosition = ++i;
    this.stimmkreiseLayerPosition = ++i;
    this.abgeordnetenPinsPosition = ++i;
    this.abgeordnetenImagesPosition = ++i;
    this.abgeordnetenTweetsPosition = ++i;
    this.abgeordnetenVideosPosition = ++i;
    this.abgeordnetenTextsPosition = ++i;

    options.center = options.center ? options.center : getCenter(options.extent);

    this.view = new ol.View({
        enableRotation: false,
        center: options.center,
        extent: options.extent,
        zoom: options.zoom,
        projection: options.projection,
        minZoom: options.minZoom,
        maxZoom: options.maxZoom,
        layers: new ol.Collection({})
    });

    this.map = new ol.Map({
        target: options.target,
        view: this.view,
        interactions: interaction.defaults({
            pinchRotate: false,
            altShiftDragRotate: false
        })
    });

    this.options = options;
}

Map.prototype.scale = function (resolution) {
    return 15 / Math.pow(resolution, 0.3);
};

Map.prototype.on = function (event, callback) {
    this.map.on(event, callback);
};

Map.prototype.getFeatureAtPixel = function (pixel, eventName) {
    let features = {};

    if (isIe()) {
        let list = [];
        this.map.forEachFeatureAtPixel(pixel, function (feature, layer) {
            let item = {};
            item['feature'] = feature;
            item['id'] = feature.getId();
            item[layer.get('name')] = true;
            item['name'] = layer.get('name');
            if (layer.get('name') !== 'stimmkreis') {
                item['abgeordneter'] = true;
            }

            if (list[layer.get('name')] === undefined) {
                list[layer.get('name')] = [];
            }
            list[layer.get('name')].push(item);
        });

        switch (eventName) {
            case 'pointermove':
                if (list['tweet'] !== undefined) {
                    features = list['tweet'][0];
                }
                break;
            case 'singleclick':
                if (list['pin'] !== undefined) {
                    features = list['pin'][0];
                } else if (list['image'] !== undefined) {
                    features = list['image'][0];
                } else if (list['stimmkreise'] !== undefined) {
                    features = list['stimmkreise'][0];
                } else if (list['abgeordneter'] !== undefined) {
                    features = list['abgeordneter'][0];
                }
                break;
            case 'dblclick':
                break;
        }

        return features;
    }

    this.map.forEachFeatureAtPixel(pixel, function (feature, layer) {
        features['feature'] = feature;
        features['id'] = feature.getId();

        features[layer.get('name')] = true;

        if (layer.get('name') !== 'stimmkreis') {
            features['abgeordneter'] = true;
        }

        return true;
    });

    return features;
};

Map.prototype.getFeatureColor = function (feature, highlight) {
    let wahlkreisFarben = {
        '1': [35, 178, 75],
        '2': [136, 21, 52],
        '3': [1, 102, 165],
        '4': [245, 130, 32],
        '5': [114, 74, 155],
        '6': [27, 143, 139],
        '7': [239, 62, 46]
    };

    let id = feature.get('ID')[0];

    //slice(0) clones color array
    let stroke = wahlkreisFarben[id].slice(0);
    let fill = wahlkreisFarben[id].slice(0);

    // set transparency
    if (highlight) {
        fill[3] = .3;
        stroke[3] = .8;
    } else {
        fill[3] = .05;
        stroke[3] = .5;
    }

    return {fill: fill, stroke: stroke};
};

Map.prototype.highlightWahlkreis = function (wahlkreis) {
    let featureColor = this.getFeatureColor;

    let bounds = new createEmpty();

    this.stimmkreiseLayer.getSource().forEachFeature(function (feature) {
        let id = feature.get('ID')[0];

        if (id.toString() === wahlkreis.toString()) {
            let color = featureColor(feature, true);

            feature.setStyle(new style.Style({
                fill: new style.Fill({color: color.fill}),
                stroke: new style.Stroke({color: color.stroke, width: 2})
            }));

            extend(bounds, feature.getGeometry().getExtent());
        } else {
            feature.setStyle(null);
        }
    });

    this.flyTo(bounds, null);
};

Map.prototype.highlightStimmkreis = function (stimmkreis) {
    let featureColor = this.getFeatureColor;

    let bounds = new createEmpty();

    this.stimmkreiseLayer.getSource().forEachFeature(function (feature) {
        let id = feature.get('ID');

        if (id.toString() === stimmkreis.toString()) {
            let color = featureColor(feature, true);

            feature.setStyle(new style.Style({
                fill: new style.Fill({color: color.fill}),
                stroke: new style.Stroke({color: color.stroke, width: 2})
            }));

            extend(bounds, feature.getGeometry().getExtent());
        } else {
            feature.setStyle(null);
        }
    });

    this.flyTo(bounds, null);
};

Map.prototype.highlightAbgeordneter = function (abgeordneter) {
    let point = new Point(this.abgeordnete[abgeordneter].koordinaten);
    point.applyTransform(proj.getTransform('EPSG:4326', this.options.projection));

    let position = point.getCoordinates();

    if (isMobile()) {
        position[1] -= 200;
    } else {
        position[0] += 200;
    }

    this.highlightStimmkreis(-1);
    this.flyTo(position, 14);
};

Map.prototype.flyTo = function (position, maxZoom) {
    maxZoom = maxZoom === null ? 14 : maxZoom;
    if (!isEmpty(position)) {
        if (position.length === 4) {
            if (isMobile()) {
                this.view.fit(position, {duration: 1000, padding: [75, 75, 475, 75]});
            } else {
                this.view.fit(position, {duration: 1000, padding: [75, 475, 75, 75]});
            }
        }

        if (position.length === 2) {
            if (isMobile()) {
                position[1] -= 100;
            } else {
                position[0] += 200;
            }

            this.view.cancelAnimations();

            let zoom = this.view.getZoom();
            let view = this.view;

            let minZoom = 10;

            if (zoom < minZoom + 1) {
                minZoom = zoom;
            }

            if (!containsXY(this.view.calculateExtent(this.map.getSize()), position[0], position[1])) {
                view.animate({
                    zoom: minZoom,
                    duration: 500
                }, function () {
                    view.animate({
                        center: position,
                        duration: 1500
                    });

                    view.animate({
                        zoom: maxZoom,
                        duration: 2000
                    });
                });
            } else {
                view.animate({
                    center: position,
                    duration: 1000
                });
                view.animate({
                    zoom: maxZoom,
                    duration: 1000
                });
            }
        }
    }
};

Map.prototype.showSatdopLayer = function () {
    this.satdopLayer.setVisible(true);
    this.webatlasLayer.setVisible(false);
    this.stimmkreiseLayer.changed();
};

Map.prototype.showWebatlasLayer = function () {
    this.webatlasLayer.setVisible(true);
    this.satdopLayer.setVisible(false);
    this.stimmkreiseLayer.changed();
};

Map.prototype.isActiveLayerSatdop = function () {
    if (this.satdopLayer.getVisible() === this.webatlasLayer.getVisible()) {
        console.warn('Exactly one layer (satellite or webatlas) should be visible, but both or none are!');
    }
    return this.satdopLayer.getVisible();
};

Map.prototype.isActiveLayerWebatlas = function () {
    if (this.satdopLayer.getVisible() === this.webatlasLayer.getVisible()) {
        console.warn('Exactly one layer (satellite or webatlas) should be visible, but both or none are!');
    }
    return this.webatlasLayer.getVisible();
};

Map.prototype.loadCapabilities = function (url, callback) {
    callback = typeof callback === 'undefined' ? null : callback;
    let deferred = Q.defer();

    let map = this.map,
        satdopLayer = this.satdopLayer,
        webatlasLayer = this.webatlasLayer,
        satdopLayerPosition = this.satdopLayerPosition,
        webatlasLayerPosition = this.webatlasLayerPosition;

    $.ajax(url)
        .then(function (response) {
            let result = (new format.WMTSCapabilities()).read(response);

            let satdop = optionsFromCapabilities(result, {
                layer: 'by_dop',
                requestEncoding: 'REST',
                matrixSet: 'smerc'
            });
            let webatlas = optionsFromCapabilities(result, {
                layer: 'by_webkarte_grau',
                requestEncoding: 'REST',
                matrixSet: 'smerc'
            });

            satdop.cacheSize = 1000000;
            webatlas.cacheSize = 1000000;

            satdopLayer.setSource(new source.WMTS(satdop));
            map.getLayers().insertAt(satdopLayerPosition, satdopLayer);

            webatlasLayer.setSource(new source.WMTS(webatlas));
            map.getLayers().insertAt(webatlasLayerPosition, webatlasLayer);

            if (callback) {
                callback();
            }

            deferred.resolve();
        });

    return deferred.promise;
};

Map.prototype.loadStimmkreise = function (url, callback) {
    callback = typeof callback === 'undefined' ? null : callback;
    let deferred = Q.defer();

    let self = this;
    let featureColor = this.getFeatureColor;

    let xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onload = function () {
        if (this.status === 200) {

            self.stimmkreiseLayer.setSource(new source.Vector({
                features: new format.KML({extractStyles: false}).readFeatures(this.response, {
                    featureProjection: self.options.projection
                })
            }));

            self.stimmkreiseLayer.getSource().forEachFeature(function (feature) {
                let id = feature.get('ID');

                if (!(id[0] in self.wahlkreise)) {
                    self.wahlkreise[id[0]] = {};
                }

                self.stimmkreise[id] = feature;
                self.wahlkreise[id[0]][id] = feature;

                feature.setId(id);
            });

            self.stimmkreiseLayer.setStyle(function (feature, resolution) {
                let id = feature.get('ID');

                let color = featureColor(feature, false);
                let text = id + (resolution < 40 && feature.get('name') ? ' - ' + feature.get('name') : '');

                return [new style.Style({
                    fill: new style.Fill({color: color.fill}),
                    stroke: new style.Stroke({color: color.stroke, width: 1}),
                    text: new style.Text({
                        textAlign: "center",
                        font: 'bold 14px sans-serif',
                        text: text,
                        fill: new style.Fill({color: color.stroke}),
                        stroke: new style.Stroke({color: [255, 255, 255, 0.5], width: 2})
                    })
                })];
            });

            self.map.getLayers().insertAt(self.stimmkreiseLayerPosition, self.stimmkreiseLayer);

            if (callback) {
                callback();
            }
        }
    };
    xhr.send();

    deferred.resolve();

    return deferred.promise;
};

Map.prototype.loadFeatures = function (baseUrl, zoomLevels, callback) {
    callback = typeof callback === 'undefined' ? null : callback;
    if (zoomLevels == null) {
        zoomLevels = [this.options.minZoom, this.options.maxZoom];
    }

    if (zoomLevels.last() < this.options.maxZoom) {
        zoomLevels.push(this.options.maxZoom);
    }

    for (let i = 0; i < zoomLevels.length - 1; i++) {
        let url = baseUrl + '?min_zoom=' + zoomLevels[i] + '&max_zoom=' + zoomLevels.last();

        if (i < zoomLevels.length - 2) {
            this.loadAbgeordnete(url, zoomLevels[i], zoomLevels[i + 1], null);
        } else {
            this.loadAbgeordnete(url, zoomLevels[i], zoomLevels[i + 1], callback);
        }
    }
};

Map.prototype.loadAbgeordnete = function (url, minZoom, maxZoom, callback) {
    callback = typeof callback === 'undefined' ? null : callback;
    let deferred = Q.defer();
    let self = this;
    let map = this.map,
        scale = this.scale,
        projection = this.options.projection,
        abgeordnete = this.abgeordnete,
        abgeordnetenPinsLayers = this.abgeordnetenPinsLayers,
        abgeordnetenImagesLayers = this.abgeordnetenImagesLayers,
        abgeordnetenTweetsLayers = this.abgeordnetenTweetsLayers,
        abgeordnetenVideosLayers = this.abgeordnetenVideosLayers,
        abgeordnetenTextsLayers = this.abgeordnetenTextsLayers,
        abgeordnetenPinsPosition = this.abgeordnetenPinsPosition,
        abgeordnetenImagesPosition = this.abgeordnetenImagesPosition,
        abgeordnetenTweetsPosition = this.abgeordnetenTweetsPosition,
        abgeordnetenVideosPosition = this.abgeordnetenVideosPosition,
        abgeordnetenTextsPosition = this.abgeordnetenTextsPosition;

    let options = {minZoom: minZoom, maxZoom: maxZoom};

    abgeordnetenPinsLayers[minZoom] = new layer.Vector($.extend({}, options, this.abgeordnetenPinsOptions));
    abgeordnetenImagesLayers[minZoom] = new layer.Vector($.extend({}, options, this.abgeordnetenImagesOptions));
    abgeordnetenTweetsLayers[minZoom] = new layer.Vector($.extend({}, options, this.abgeordnetenTweetsOptions));
    abgeordnetenVideosLayers[minZoom] = new layer.Vector($.extend({}, options, this.abgeordnetenVideosOptions));
    abgeordnetenTextsLayers[minZoom] = new layer.Vector($.extend({}, options, this.abgeordnetenTextsOptions));

    $.getJSON(url)
        .then(function (res_features) {
            let pinFeatures = [];
            let imageFeatures = [];
            let tweetFeatures = [];
            let videoFeatures = [];
            let textFeatures = [];
            /*
                        res_features = Object.values(res_features);

                        res_features.sort(function (a, b) {
                            if (a.abgeordneter.sortkey > b.abgeordneter.sortkey) return 1;
                            if (a.abgeordneter.sortkey < b.abgeordneter.sortkey) return -1;

                            return 0;
                        }); // TODO ? neded ?
            */
            $.each(res_features, function () {
                let id = this.id;
                let point = new Point(this.koordinaten);
                point.applyTransform(proj.getTransform('EPSG:4326', projection));

                let svgs = ['pin', 'image', 'tweet', 'video', 'text'].map(function (v) {
                    let img = new style.Icon({
                        src: url + '&id=' + id + '&type=' + v,
                        imgSize: [200, 200],
                        scale: 1.5
                    });

                    let svg = new style.Style();

                    let feature = new Feature({geometry: point});
                    feature.setId(id);
                    feature.setStyle(function (feature, resolution) {
                        if (!(v === "tweet" && abgeordnete[id].tweets.overlay === null)) {
                            img.setScale(scale(resolution));
                            svg.setImage(img);
                        }

                        return svg;
                    });

                    return feature;
                });

                pinFeatures.push(svgs[0]);
                imageFeatures.push(svgs[1]);
                tweetFeatures.push(svgs[2]);
                videoFeatures.push(svgs[3]);
                textFeatures.push(svgs[4]);

                abgeordnete[id] = this;

                $.getJSON(url + '&id=' + id + '&type=offset').then(function (data) {
                    abgeordnete[id]['pin'] = data;
                });
            });

            self.abgeordnetenPinsLayers[minZoom].setSource(new source.Vector({features: pinFeatures}));
            self.map.getLayers().insertAt(self.abgeordnetenPinsPosition, self.abgeordnetenPinsLayers[minZoom]);

            abgeordnetenImagesLayers[minZoom].setSource(new source.Vector({features: imageFeatures}));
            map.getLayers().insertAt(abgeordnetenImagesPosition, abgeordnetenImagesLayers[minZoom]);

            abgeordnetenTweetsLayers[minZoom].setSource(new source.Vector({features: tweetFeatures}));
            map.getLayers().insertAt(abgeordnetenTweetsPosition, abgeordnetenTweetsLayers[minZoom]);

            abgeordnetenVideosLayers[minZoom].setSource(new source.Vector({features: videoFeatures}));
            map.getLayers().insertAt(abgeordnetenVideosPosition, abgeordnetenVideosLayers[minZoom]);

            abgeordnetenTextsLayers[minZoom].setSource(new source.Vector({features: textFeatures}));
            map.getLayers().insertAt(abgeordnetenTextsPosition, abgeordnetenTextsLayers[minZoom]);

            if (callback) {
                callback();
            }
        });

    deferred.resolve();

    return deferred.promise;
};

Map.prototype.getAbgeordnetenKeys = function (twitter_mode) {

    twitter_mode = typeof twitter_mode === 'undefined' ? false : twitter_mode;
    let abgeordnete = this.abgeordnete;
    let abgeordnetenKeys = [];
    for (let id in abgeordnete) {
        if (abgeordnete.hasOwnProperty(id)) {
            if (twitter_mode) {
                if (abgeordnete[id].tweets.overlay !== null) {
                    abgeordnetenKeys.push(id);
                }
            } else {
                abgeordnetenKeys.push(id);
            }
        }
    }

    abgeordnetenKeys.sort(function (a, b) {
        if (abgeordnete[a].abgeordneter.sortkey > abgeordnete[b].abgeordneter.sortkey) return 1;
        if (abgeordnete[a].abgeordneter.sortkey < abgeordnete[b].abgeordneter.sortkey) return -1;

        return 0;
    });

    return abgeordnetenKeys;
};

Map.prototype.loadTweets = function (url, callback) {
    callback = typeof callback === 'undefined' ? null : callback;
    let abgeordnete = this.abgeordnete;

    $.getJSON(url).then(function (data) {
        $.each(data, function (id) {
            if (typeof abgeordnete[id] !== 'undefined') {
                abgeordnete[id]['tweets'] = this;
            }
        });

        if (callback) {
            callback();
        }
    });
};

export default Map;
